<template>
    <div class="inc-main-div">
        <HeaderCallConnect />
        <MainCallConnect @closeDialog="closeDialog" />
    </div>
</template>
<script setup lang="ts">
import { ModalNames } from '~/types/modals';
import HeaderCallConnect from './HeaderCallConnected.vue';
import MainCallConnect from './MainCallConnected.vue';

const dialogRef = getDialogRef(ModalNames.OUTGOING_CALL_CONNECTED);
const closeDialog = () => {
    dialogRef.value.close();
};
</script>
<style lang="scss" scoped>
.inc-main-div {
    @apply sm:max-w-md sm:w-[440px] w-11/12 rounded-lg bg-zinc-950 mx-auto h-auto overflow-y-auto;
}
</style>
